// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `fi-checklist-checkpoint-mandatory-info {
  display: block;
  color: var(--fi-color-dark);
  transition: color 0.12s linear;
}
fi-checklist-checkpoint-mandatory-info.error {
  color: var(--fi-color-red);
}`, "",{"version":3,"sources":["webpack://./Source/app/checklist/common/checkpoint-mandatory-info.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,2BAAA;EACA,8BAAA;AACJ;AACI;EACI,0BAAA;AACR","sourcesContent":["fi-checklist-checkpoint-mandatory-info {\r\n    display: block;\r\n    color: var(--fi-color-dark);\r\n    transition: color 0.12s linear;\r\n\r\n    &.error {\r\n        color: var(--fi-color-red);\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
